exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep button.fab {\n  position: fixed;\n\tbottom: 30px;\n\tright: 30px;\n\twidth: 56px;\n}\n\n::ng-deep .forminput .mat-input-element:disabled{\n  color: #90e57e;\n}\n\n::ng-deep .forminput .mat-input-placeholder {\n  color: #fff;\n}\n\n::ng-deep .forminput.mat-focused .mat-input-placeholder {\n  color: #43a047;\n}\n\n::ng-deep .forminput .mat-form-field-underline {\n  background-color: #fff;\n}\n\nh1 {\n  font-family: 'Roboto', sans-serif;\n  font-size: 30px;\n  font-weight: 300;\n}\n\n.row.title {\n  margin-top: 20px;\n}\n\n.row.content {\n  margin-top: 30px;\n  padding-bottom: 20px;\n}\n\n.row.content > [class*='col-'] > button {\n  margin-top: 15px;\n}\n\n.aboutarea, .imagearea {\n  margin-top: 30px;\n}\n\n.forminput {\n  width: 100%;\n  color:#eeddbb;\n  font-family: 'Roboto', sans-serif;\n  font-size: 16px;\n  font-weight: 300;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/profile-about/profile-about.component.css
// module id = ../../../../../src/app/profile-about/profile-about.component.css
// module chunks = main